export const environment = {
  production: true,
  hmr: false,
  debug: false,
  client: 'Polaris',
  hostName: 'https://polarisus-analytics-prod.azurewebsites.net',
  environmentName: 'production',
  appName: 'Polaris Analytics',
  ssoPassword: 'ShiftDigital#123',
  applicationInsights: {
    instrumentationKey: '22ed8b73-8870-4725-a931-ae6ed7a1fd7b'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Eastern Standard Time',
  showLocaleSelector: 'true',
  numberOfMonthsToShowDefault: 12,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  defaultChartColors: ['#1b365c', '#47ddfc', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  baseApiUri: 'https://polarisus-analytics-api-prod.azurewebsites.net/api',
  authUri: 'https://polarisus-analytics-api-prod.azurewebsites.net/token',
  baseV5ApiUri: 'https://polarisus-analytics-apiv5-prod.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: true,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/polaris/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: true,
  harmonyUrl: '',
  v5Reports: ['WebsiteOverview']
};
